import Emitter from "es6-event-emitter";

import language from "./../../dictionary";
import template from "./../../templates/settings/settingLandscapeToggle.dust";

import {
  OPENED_LANDSCAPE_TOGGLE_SETTINGS,
  CLICKED_BACK_LANDSCAPE_TOGGLE,
  CLICKED_CLOSE_LANDSCAPE_TOGGLE,
  CLICKED_DOUBLEPAGE_TOGGLE_SETTINGS,
  CLICKED_SINGLEPAGE_TOGGLE_SETTINGS,
} from "./../../analytics/analyticsevents";

export default class SettingLandscapeToggle extends Emitter {
  constructor(appState) {
    super();
    this._appState = appState;
    this._DOMContainer = document.querySelector("#sidemenu-account-container");
  }

  render() {
    const context = {};
    context.back = true;
    context.close = true;
    context.i18n = language;
    context.doublePage = this._appState.isDoublePage;
    context.title = this._appState.isDesktop
      ? language.readingModeToggle
      : language.landscapeToggle;
    if (this._DOMContainer) {
      Dust.render(template, context, (err, result) => {
        this._DOMContainer.innerHTML = result;
        this._DOMContainer.classList.remove("hidden");
        this._appState.triggerEvent(OPENED_LANDSCAPE_TOGGLE_SETTINGS);
        this._attachListeners();
      });
    }
  }

  //////////////

  /**
   * @todo Top bar with back/close buttons and title might be separate component as
   * logic there seems to be the same for all settings options - check that later
   */

  _attachListeners() {
    this.backButtonEl = this._DOMContainer.querySelector(
      ".overlay-navigation-back"
    );
    this.backButtonEl.addEventListener(
      "click",
      this._backButtonClickHandler.bind(this)
    );

    this.closeButtonEl = this._DOMContainer.querySelector(
      ".overlay-navigation-close"
    );
    this.closeButtonEl.addEventListener(
      "click",
      this._closeButtonClickHandler.bind(this)
    );

    this.optionsEl = document.getElementById("landscape-options");
    this.optionsEl.addEventListener(
      "change",
      this._landscapeOptionsClickHandler.bind(this)
    );
  }

  _detachListeners() {
    this.backButtonEl.removeEventListener(
      "click",
      this._backButtonClickHandler
    );
    this.closeButtonEl.removeEventListener(
      "click",
      this._closeButtonClickHandler
    );
  }

  _backButtonClickHandler() {
    this._hide();
    this._appState.triggerEvent(CLICKED_BACK_LANDSCAPE_TOGGLE);
  }

  _closeButtonClickHandler() {
    this._hide();
    this.trigger("settingLandscapeToggle:closed");
    this._appState.triggerEvent(CLICKED_CLOSE_LANDSCAPE_TOGGLE);
  }

  _landscapeOptionsClickHandler(e) {
    const options = this.optionsEl.querySelectorAll(".landscape-option");
    [].forEach.call(options, (node) => {
      node.classList.remove("is-selected");
    });
    $(e.target).closest(".landscape-option").addClass("is-selected");
    this.chosenOption = e.target.value;
    this.trigger("settingLandscapeToggle:changed", this.chosenOption);
    if (this.chosenOption === "doublePage") {
      this._appState.triggerEvent(CLICKED_DOUBLEPAGE_TOGGLE_SETTINGS);
    } else {
      this._appState.triggerEvent(CLICKED_SINGLEPAGE_TOGGLE_SETTINGS);
    }
  }

  _hide() {
    if (this.chosenOption) {
      this._appState.isDoublePage = this.chosenOption === "doublePage";
    }
    this._detachListeners();
    this._DOMContainer.innerHTML = "";
    this._DOMContainer.classList.add("hidden");
  }
}



// WEBPACK FOOTER //
// ./src/common/components/settings/settingLandscapeToggle.js